module.exports = __webpack_public_path__ + "media/icons/heart-8fa3bf26.svg";